export const EDIT_REGISTRATION_FORM_REQUEST = 'EDIT_REGISTRATION_FORM_REQUEST';
export const EDIT_REGISTRATION_FORM_SUCCESS = 'EDIT_REGISTRATION_FORM_SUCCESS';
export const EDIT_REGISTRATION_FORM_FAILED = 'EDIT_REGISTRATION_FORM_FAILED';

export const GET_REGISTRATION_FORM_REQUEST = 'GET_REGISTRATION_FORM_REQUEST';
export const GET_REGISTRATION_FORM_SUCCESS = 'GET_REGISTRATION_FORM_SUCCESS';
export const GET_REGISTRATION_FORM_FAILED = 'GET_REGISTRATION_FORM_FAILED';
